import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { PinAddressMapComponent } from "./shared/commonComponent/PinAddress_Map/PinAddressMap.component";
import { AuthGuard } from "./shared/helpers/auth.guard";
// import { MerchantResolver } from "./shared/helpers/merchant.resolver";

// Define the routes for different components/modules
const routes: Routes = [
  {
    path: "",
    // resolve: { merchant: MerchantResolver },
    loadChildren: () => import("./home/home.module").then((m) => m.HomeModule),
  },
  {
    path: "login",
    // resolve: { merchant: MerchantResolver },
    loadChildren: () => import("./auth/auth.module").then((m) => m.AuthModule),
  },
  {
    path: "categories",
    // resolve: { merchant: MerchantResolver },
    loadChildren: () =>
      import("./home/category/category.module").then((m) => m.CategoryModule),
  },
  {
    path: "dashboard",
    // resolve: { merchant: MerchantResolver },
    // canActivate: [AuthGuard], // Protected route requiring authentication
    loadChildren: () =>
      import("./dashboard/dashboard.module").then((m) => m.DashboardModule),
  },
  {
    path: "category",
    canActivate: [AuthGuard], // Protected route requiring authentication
    // resolve: { merchant: MerchantResolver },
    loadChildren: () =>
      import("./category/category.module").then((m) => m.CategoryModule),
  },
  {
    path: "new-category",
    canActivate: [AuthGuard], // Protected route requiring authentication
    // resolve: { merchant: MerchantResolver },
    loadChildren: () =>
      import("./new-category/new-category.module").then(
        (m) => m.NewCategoryModule,
      ),
  },
  {
    path: "subcategory",
    canActivate: [AuthGuard], // Protected route requiring authentication
    // resolve: { merchant: MerchantResolver },
    loadChildren: () =>
      import("./sub-category/sub-category.module").then(
        (m) => m.SubCategoryModule,
      ),
  },
  {
    path: "nastedcategory",
    canActivate: [AuthGuard], // Protected route requiring authentication
    // resolve: { merchant: MerchantResolver },
    loadChildren: () =>
      import("./nasted-category/nasted-category.module").then(
        (m) => m.NastedCategoryModule,
      ),
  },
  {
    path: "products",
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always",
    // resolve: { merchant: MerchantResolver },
    loadChildren: () =>
      import("./products/products.module").then((m) => m.ProductsModule),
  },
  {
    path: "basket",
    canActivate: [AuthGuard], // Protected route requiring authentication
    // resolve: { merchant: MerchantResolver },
    loadChildren: () =>
      import("./basket/basket.module").then((m) => m.BasketModule),
  },
  {
    path: "fulfillment-selection",
    canActivate: [AuthGuard], // Protected route requiring authentication
    // resolve: { merchant: MerchantResolver },
    loadComponent: () =>
      import("./fulfillment-selection/fulfillment-selection.component").then(
        (m) => m.FulfillmentSelectionComponent,
      ),
  },
  {
    path: "pay",
    canActivate: [AuthGuard], // Protected route requiring authentication
    // resolve: { merchant: MerchantResolver },
    loadChildren: () => import("./pay/pay.module").then((m) => m.PayModule),
  },
  {
    path: "about",
    // resolve: { merchant: MerchantResolver },
    loadChildren: () =>
      import("./about/about.module").then((m) => m.AboutModule),
  },
  {
    path: "websitenotfound",
    // resolve: { merchant: MerchantResolver },
    loadChildren: () =>
      import("./websitenotfound/websitenotfound.module").then(
        (m) => m.websitenotfoundModule,
      ),
  },
  {
    path: "scanner",
    // resolve: { merchant: MerchantResolver },
    loadChildren: () =>
      import("./scanner/scanner.module").then((m) => m.ScannerModule),
  },
  {
    path: "receipt",
    canActivate: [AuthGuard], // Protected route requiring authentication
    // resolve: { merchant: MerchantResolver },
    loadChildren: () =>
      import("./receipt/receipt.module").then((m) => m.ReceiptModule),
  },
  {
    path: "PinAddress",
    component: PinAddressMapComponent, // Component to be rendered
    canActivate: [AuthGuard], // Protected route requiring authentication
    // resolve: { merchant: MerchantResolver },
    loadChildren: () =>
      import("./shared/commonComponent/PinAddress_Map/PinAddressMap.module").then(
        (m) => m.PinAddressMapModule,
      ),
  },
  {
    path: "profile",
    canActivate: [AuthGuard], // Protected route requiring authentication
    // resolve: { merchant: MerchantResolver },
    loadChildren: () =>
      import("./user-profile/user-profile.module").then(
        (m) => m.UserProfileModule,
      ),
  },
];

@NgModule({
  // imports: [ RouterModule.forRoot(routes, { enableTracing: false }) ],
  imports: [RouterModule.forRoot(routes, { enableTracing: false })],

  exports: [RouterModule],
})
export class AppRoutingModule {}
